import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07771837"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mk-card-block" }
const _hoisted_2 = { class: "select-container" }
const _hoisted_3 = { class: "select-item" }
const _hoisted_4 = { class: "select-title" }
const _hoisted_5 = {
  key: 1,
  class: "tips"
}
const _hoisted_6 = { class: "selected" }
const _hoisted_7 = { class: "select-title" }
const _hoisted_8 = { class: "select-data" }
const _hoisted_9 = { class: "item" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "text--right" }

import { ref, reactive, onMounted, getCurrentInstance, watch, computed } from "vue";
import { useBrandsByUser, usePlatformsByUser, useLanguages, useVodLanguages } from '@/utils/cacheData'
import { getModel2 } from '@/api/common'
import { deepCloneByJSON, getArrByReduce, unique } from "@/utils/tools";
import { elMessage, getTextWidth } from "@/utils";
import { useCommon } from '@/store/useCommon'
import { useI18n } from "vue-i18n";

type ResType = {
  code: string,
  data: any,
  [propName: string]: any
}

// 获取登录人信息

export default /*#__PURE__*/_defineComponent({
  __name: 'TheModel',
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  data: {
    type: Array,
    default: () => []
  },
  apkList: {
    type: Array,
    default: []
  },
  dialogTitle: {
    type: String,
    default: '选择Model'
  }
},
  setup(__props) {

const props = __props;

const { t } = useI18n()
const { emit } = getCurrentInstance()



const checkREF = ref(null)

const store = useCommon()
const user = store.userData


//  内容超出时显示提示
const tipDisabled = ref(false)
const showTextTip = (e) => {
  const target = e.target
  const width = getTextWidth(target.innerText)
  tipDisabled.value = target.offsetWidth < width
}

let Visible = ref(false)
watch(() => props.visible, val => {
  Visible.value = val
}, { immediate: true })
const loading = ref(false)
const validateCid = (rule, value, callback) => {
  if (!value) {
    callback(new Error(t('请选择品牌')))
  }
  callback()
}
const validatePid = (rule, value, callback) => {
  if (!value) {
    callback(new Error(t('请选择平台')))
  }
  callback()
}
// 选择model弹框
const editModel = reactive({
  toolbar: [],
  dialogOptions: {
    fullscreen: false,
    title: '选择Model',
    width: '70%',
  },
  formlist: [
    {
      prop: 'name',
      label: '名称',
      widgetType: 'input',
    },
    {
      prop: 'language',
      label: '语言',
      list: [],
      widgetType: 'Select'
    },
  ],
  rules: {
    name: [

    ],
    language: [

    ]
  },
  formdata: {
    cid: [],
    pid: [],
  },
  search: () => {
    getModelData()
  }
})

// 回显已选的所有数据
const allSelecteds = reactive({
  data: [],
  ids: []
})

// 所有model数据
const cityOptions = ref([])
const checkBox = reactive({
  checkAll: false,            //  是否全选
  checkedCities: [],          //  已选择数据
  cities: cityOptions.value,   //  可选数据
  isIndeterminate: true,
})

const onClose = () => {
  emit('update:visible', false)
  emit('on-close')
  if (user.roles.includes('VNO')) {
    const { cid } = user
    editModel.formdata.cid = []
    editModel.formdata.cid.push(String(cid[0]))
  }
}
const reset = () => {
  if (user.roles.includes('VNO')) {
    editModel.formdata.cid.push(editModel.formlist[0].list[0].value)
  }
}
// 获取Model数据
onMounted(() => {
  checkBox.cities = [...props.apkList]
  // getBrand()
  // getLanguages()
})
// 获取品牌数据
const getBrand = async () => {
  const brands = await useBrandsByUser()
  editModel.formlist[0].list = brands.map(item => (
    {
      label: item.prefixName,
      value: String(item.cid)
    }
  ))
  if (user.roles.includes('VNO')) {
    editModel.formlist[0].disabled = true
    editModel.formdata.cid.push(String(brands[0].cid))
  }
}
// 获取语言
const getLanguages = async () => {
  const langs = await useVodLanguages()
  editModel.formlist[1].list = langs
}

const flag = ref(true)
const getModelData = async () => {
  if (editModel.formdata.cid.length !== 0 || editModel.formdata.pid.length !== 0) {
    loading.value = true
    checkBox.cities = []

    // 本地查询model
    if (user.model) {
      console.log('查询本地model')
      const { cid, pid } = editModel.formdata
      let models = user.model.filter(ii => {
        return (cid.length > 0 ? cid.includes(String(ii.cid)) : true) && (pid.length > 0 ? pid.includes(String(ii.pid)) : true)
      })
      cityOptions.value = models
      checkBox.cities = [...props.apkList, ...models]
      loading.value = false
      // 回显已选数据
      flag.value = false
      echoData(models)
    } else {
      console.log('查询远程model', editModel.formdata)
      // 查询远程model
      const cids = editModel.formdata.cid.join(',')
      const pids = editModel.formdata.pid.join(',')
      const res = await getModel2({ cids, pids, limit: 1000 }) as ResType
      cityOptions.value = res.data
      checkBox.cities = [...props.apkList, ...res.data]
      loading.value = false
      // 回显已选数据
      flag.value = false
      echoData(res.data)
    }
  } else {
    elMessage('warning', '请选择筛选数据')
  }
}
// 回显已选数据
const echoData = (data) => {
  // 获取已经选择的id
  let ids = getArrByReduce(allSelecteds.data, 'id')
  checkBox.checkedCities = []
  // 从所有已选数据中筛选需要回显的数据
  checkBox.checkedCities = data.filter(item => ids.includes(item.id))
  allSelecteds.ids = getArrByReduce(allSelecteds.data, 'id')
  handleCheckedModelChange(checkBox.checkedCities)
}
// 是否勾选
const isCheck = id => {
  return allSelecteds.ids.includes(id)
}


// 点击确定按钮
const editModelConfirm = () => {
  console.log('allSelecteds.data', allSelecteds.data);

  emit('update:data', JSON.parse(JSON.stringify(allSelecteds.data)))
  emit('update:visible', false)
}
// 点击全选按钮
const handleCheckAllChange = (val) => {
  // allSelecteds.data = val ? JSON.parse(JSON.stringify(checkBox.cities)) : []
  allSelecteds.data = val ? unique(deepCloneByJSON(checkBox.cities).concat(allSelecteds.data), 'id') : cancelSelect(allSelecteds.data, checkBox.cities)
  // 手动回显
  echoData(checkBox.cities)
  // 如果使用深拷贝，没法实现全选视觉效果。浅拷贝的话，如果删除右侧数据，左侧数据又会同步删掉
  // 所以只能使用上面的手动回显方式
  // checkBox.checkedCities = val ? JSON.parse(JSON.stringify(checkBox.cities)) : []
  checkBox.isIndeterminate = false
}
// 取消已选数据
const cancelSelect = (originList = [], targetList = []) => {
  let cancelIds = getArrByReduce(targetList, 'id')
  return originList && originList.filter(originItem => !cancelIds.includes(originItem.id))
}

// 点击多选框
const handleCheckedModelChange = (value) => {
  const checkedCount = value.length
  checkBox.checkAll = checkedCount === checkBox.cities.length
  checkBox.isIndeterminate = checkedCount > 0 && checkedCount < checkBox.cities.length
}
// 删除已选数据操作
const handleClose = (tag) => {
  allSelecteds.data = cancelSelect(allSelecteds.data, [tag])
  checkBox.checkedCities = cancelSelect(checkBox.checkedCities, [tag])
}

const checkBoxChange = (val, data) => {
  if (val) {
    allSelecteds.data.push(data)
  } else {
    allSelecteds.data = cancelSelect(allSelecteds.data, [data])
  }
}
watch(() => props.visible, (val) => {
  if (val) {
    getLanguages()
    allSelecteds.data = JSON.parse(JSON.stringify(props.data))
    // 如果是vno用户，禁用选用品牌
    if (user.roles.includes('VNO')) {
      editModel.formlist[0].disabled = true
    } else {
      editModel.formlist[0].disabled = false
    }
    // 回显已选数据
    echoData(checkBox.cities)
  }
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_search_form = _resolveComponent("search-form")!
  const _component_MPopper = _resolveComponent("MPopper")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(Visible),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(Visible) ? (Visible).value = $event : Visible = $event)),
    title: __props.dialogTitle,
    width: "60%",
    onClose: onClose,
    "destroy-on-close": "",
    "close-on-click-modal": false,
    "append-to-body": "",
    "lock-scroll": false
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_el_button, {
          class: "mk-op-btn mk-op-btn-non-focus",
          onClick: onClose
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('关闭')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "mk-op-btn mk-op-btn-main",
          onClick: editModelConfirm
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('确定')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_search_form, {
        formList: editModel.formlist,
        formData: editModel.formdata,
        formRules: editModel.rules,
        onSearch: editModel.search,
        onReset: reset,
        gutter: 20
      }, null, 8, ["formList", "formData", "formRules", "onSearch"]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('选择人员')), 1),
            (checkBox.cities.length > 0)
              ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
                  key: 0,
                  class: "check-group",
                  modelValue: checkBox.checkedCities,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkBox.checkedCities) = $event)),
                  onChange: handleCheckedModelChange,
                  ref_key: "checkREF",
                  ref: checkREF
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkBox.cities, (city) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        key: city,
                        label: city,
                        checked: isCheck(city.id),
                        onChange: ($event: any) => (checkBoxChange($event, city)),
                        class: "checkbox"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_MPopper, {
                            disabled: tipDisabled.value,
                            placement: "top",
                            trigger: "hover",
                            content: city.modelName
                          }, {
                            reference: _withCtx(() => [
                              _createElementVNode("span", {
                                onMouseover: showTextTip,
                                class: "item-name"
                              }, _toDisplayString(city.modelName), 33)
                            ]),
                            _: 2
                          }, 1032, ["disabled", "content"])
                        ]),
                        _: 2
                      }, 1032, ["label", "checked", "onChange"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('暂无数据')), 1))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('已选数据')), 1),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allSelecteds.data, (tag, index) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_MPopper, {
                    disabled: tipDisabled.value,
                    placement: "top",
                    trigger: "hover",
                    content: tag.modelName
                  }, {
                    reference: _withCtx(() => [
                      _createElementVNode("span", {
                        onMouseover: showTextTip,
                        class: "item-name"
                      }, _toDisplayString(tag.modelName), 33)
                    ]),
                    _: 2
                  }, 1032, ["disabled", "content"]),
                  _createElementVNode("span", {
                    class: "delete",
                    onClick: ($event: any) => (handleClose(tag))
                  }, _toDisplayString(_ctx.$t('删除')), 9, _hoisted_10)
                ]))
              }), 256))
            ])
          ])
        ])
      ])), [
        [_directive_loading, loading.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})